<template>
  <div class="select-wrapper">
    <div class="select-label" v-if="label">{{ label }}</div>
    <div class="select-container" @click="togglePicker">
      <div class="select-content van-ellipsis">
        <span v-if="selectedText" class="selected-text">{{ selectedText }}</span>
        <span v-else class="placeholder">{{ placeholder }}</span>
      </div>
      <i class="select-arrow" :class="{ 'is-reverse': showPicker }"></i>
    </div>
    <!-- 使用原生 HTML 实现下拉面板 -->
    <transition name="slide-fade">
      <div v-show="showPicker" class="select-dropdown">
        <div class="select-options">
          <div
            v-for="option in options"
            :key="option.value"
            class="select-option van-ellipsis"
            :class="{ 'select-option-active': modelValue === option.value }"
            @click="onSelect(option)"
          >
            {{ option.text }}
          </div>
        </div>
      </div>
    </transition>
    <!-- 点击外部关闭下拉面板的遮罩层 -->
    <div v-show="showPicker" class="select-mask" @click="showPicker = false"></div>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data() {
    return {
      showPicker: false
    }
  },
  computed: {
    selectedText() {
      const selected = this.options.find(option => option.value === this.modelValue)
      return selected ? selected.text : ''
    }
  },
  methods: {
    togglePicker() {
      this.showPicker = !this.showPicker
    },
    onSelect(option) {
      this.$emit('update:modelValue', option.value)
      this.showPicker = false
    }
  }
}
</script>

<style lang="scss" scoped>
.select-wrapper {
  position: relative;
  
  .select-label {
    font-size: 15px;
    color: #333;
    margin-bottom: 8px;
  }

  .select-container {
    position: relative;
    height: 44px;
    background: #F5F5F5;
    border-radius: 8px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 2;

    .select-content {
      flex: 1;
      .selected-text {
        color: #5F5F5F;
      }
      .placeholder {
        color: #999;
      }
    }

    .select-arrow {
      width: 12px;
      height: 12px;
      border-right: 2px solid #999;
      border-bottom: 2px solid #999;
      transform: rotate(45deg);
      margin-top: -6px;
      transition: transform 0.3s;

      &.is-reverse {
        transform: rotate(-135deg);
        margin-top: 6px;
      }
    }
  }

  .select-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: -8px;
    background: #fff;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    z-index: 1;
    padding-top: 8px;
  }

  .select-options {
    max-height: 240px;
    overflow-y: auto;
    padding: 8px 0;

    .select-option {
      height: 44px;
      line-height: 44px;
      padding: 0 16px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        background-color: #f5f5f5;
      }
      
      &.select-option-active {
        color: #FF9C47;
      }
    }
  }

  .select-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }
}

// 过渡动画
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style> 